import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from "../../components/components.module";
import { PipesModule } from '../../pipes/pipes.module';
import { HelpPage } from './help';

@NgModule({
  declarations: [
    HelpPage,
  ],
  imports: [
    IonicPageModule.forChild(HelpPage),
    ComponentsModule,
    PipesModule,
  ],
})
export class HelpPageModule { }



// WEBPACK FOOTER //
// ./src/pages/help/help.module.ts